/* eslint-disable import/first */
// shared css require needs to come first so component css can override shared css without needing !important
require('@alltrails/shared/sharedCss.css');

import FooterWrapper from 'components/FooterWrapper';
import GlobalActions from 'components/GlobalActions';
import NavBar from 'components/NavBar';
import PhotoPage from 'pages/PhotoPage';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const ReactRailsUJS = require('react_ujs');

const context = {
  NavBar,
  FooterWrapper,
  PhotoPage,
  GlobalActions
};

ReactRailsUJS.getConstructor = className => context[className];
